import React from 'react'
import { Input, Btn } from '../ui/index.jsx'
import { useLanguage } from '../../i18n/index.jsx'
import type { Department } from '../../types/domain'

interface ProfileForm {
  work_title: string
  email: string
  phone: string
  department_id: string | number | null
}

interface ProfileEditorProps {
  profile: ProfileForm
  setProfile: (profile: ProfileForm) => void
  departments: Department[] | null
  profileLoading: boolean
  profileSuccess: boolean
  onSave: React.FormEventHandler<HTMLFormElement>
}

export default function ProfileEditor({ profile, setProfile, departments, profileLoading, profileSuccess, onSave }: ProfileEditorProps) {
  const { t } = useLanguage()

  return (
    <div style={{ paddingBottom: '1rem', borderBottom: '1px solid var(--border-subtle)' }}>
      <h3 style={{ fontSize: 'var(--text-base)', fontWeight: 600, marginBottom: '1rem' }}>{t('contactInformation')}</h3>
      <form onSubmit={onSave} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <Input
          label={t('profileWorkTitle')}
          type="text"
          placeholder={t('profileWorkTitlePlaceholder')}
          value={profile.work_title}
          onChange={e => setProfile({ ...profile, work_title: e.target.value })}
          disabled={profileLoading}
        />
        {departments && departments.length > 0 && (
          <div>
            <label style={{ display: 'block', fontSize: 'var(--text-sm)', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 4 }}>
              {t('profileDepartment')}
            </label>
            <select
              value={profile.department_id || ''}
              onChange={e => setProfile({ ...profile, department_id: e.target.value })}
              disabled={profileLoading}
              className="field-input field-select"
              style={{ width: '100%' }}
            >
              <option value="">{t('profileSelectDepartment')}</option>
              {departments.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
            </select>
          </div>
        )}
        <Input
          label={t('profileEmail')}
          type="email"
          placeholder="you@example.com"
          value={profile.email}
          onChange={e => setProfile({ ...profile, email: e.target.value })}
          disabled={profileLoading}
        />
        <Input
          label={t('profilePhone')}
          type="tel"
          placeholder="+45 12 34 56 78"
          value={profile.phone}
          onChange={e => setProfile({ ...profile, phone: e.target.value })}
          disabled={profileLoading}
        />
        <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
          {profileSuccess && (
            <span style={{ fontSize: 'var(--text-caption)', color: 'var(--success)', alignSelf: 'center' }}>
              ✓ Saved
            </span>
          )}
          <Btn variant="primary" size="sm" type="submit" loading={profileLoading}>
            {t('save')}
          </Btn>
        </div>
      </form>
    </div>
  )
}
